/**
 * src/components/ui/Card.jsx
 */

export function Card({ children, title, subtitle, action, style: extra = {}, padding = '20px' }) {
  return (
    <div style={{
      background: 'var(--color-surface)',
      border: '1px solid var(--color-border)',
      borderRadius: '10px',
      overflow: 'hidden',
      ...extra,
    }}>
      {(title || action) && (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '14px 20px',
          borderBottom: '1px solid var(--color-border)',
        }}>
          <div>
            <div style={{
              fontSize: '13px', fontWeight: 600, color: 'var(--color-text)',
              letterSpacing: '-0.01em',
            }}>{title}</div>
            {subtitle && (
              <div style={{ fontSize: '11px', color: 'var(--color-text-3)', marginTop: '1px' }}>
                {subtitle}
              </div>
            )}
          </div>
          {action && <div>{action}</div>}
        </div>
      )}
      <div style={{ padding }}>{children}</div>
    </div>
  )
}

export function KpiCard({ label, value, sub, color = 'var(--color-accent)' }) {
  return (
    <div style={{
      background: 'var(--color-surface)',
      border: '1px solid var(--color-border)',
      borderRadius: '10px', padding: '18px 20px',
    }}>
      <div style={{
        fontSize: '11px', fontWeight: 500, color: 'var(--color-text-3)',
        letterSpacing: '0.1em', marginBottom: '8px', fontFamily: 'var(--font-mono)',
      }}>
        {label}
      </div>
      <div style={{
        fontSize: '28px', fontWeight: 700, color,
        fontFamily: 'var(--font-mono)', lineHeight: 1, letterSpacing: '-0.02em',
      }}>
        {value}
      </div>
      {sub && (
        <div style={{
          fontSize: '11px', color: 'var(--color-text-3)', marginTop: '6px',
        }}>
          {sub}
        </div>
      )}
    </div>
  )
}
